export default __webpack_public_path__ + "static/media/04.81f755a0.png";